export default "assets/images/icons/garde-2354c391.svg";